module.exports = __webpack_public_path__ + "img/calendar-range-fill.af8fbb8a.svg";